module.exports = kolibriCoreAppGlobal.heartbeat;